import { moduleFactory } from "@/factories/module";
import { clientEnvBuildInfo } from "@/modules/client-env/buildInfo";
import {
  clientEnvNodeEnvironment,
  clientEnvNodeEnvironmentIsDev,
  clientEnvNodeEnvironmentIsProd,
  clientEnvNodeEnvironmentIsTest,
} from "@/modules/client-env/nodeEnvironment";
import { clientEnvPackageVersion } from "@/modules/client-env/packageVersion";
import { clientEnvLocalBackendApiIsEnabled } from "@/modules/client-env/viteConfig";

export const clientEnvModule = moduleFactory.create({
  nodeEnv: clientEnvNodeEnvironment,
  isProd: clientEnvNodeEnvironmentIsProd,
  isDev: clientEnvNodeEnvironmentIsDev,
  isTest: clientEnvNodeEnvironmentIsTest,
  localBackendApiIsEnabled: clientEnvLocalBackendApiIsEnabled,
  buildInfo: clientEnvBuildInfo,
  packageVersion: clientEnvPackageVersion,
});
